import React, { useEffect, useState, useCallback, useRef } from "react";
import {useDispatch, useSelector} from "react-redux";
import {Confirm2Modal} from "../../../util/component/Modal/Modal";
import { IoCloseSharp } from "react-icons/io5";
import update from "immutability-helper";

const CustomTextAreaList = ({ data, optionChanged,
                                dataList,setDataList,changeData,updateListRow,openState}) => {


    const [textValue, setTextValue] = useState();
    useEffect(()=>{
            updateListRow();
            setTextValue(data?.value);
        }
        ,[]);

    const _onRemarkConfirm = (value) => {
        //SetRemark(value);
        optionChanged (value);
    }
    const change = (idx, value, name) => {
        setDataList(D => update(D, {
            [idx]: { [name]: { $set: value } }
        }))
    }
    const _changeRemark = (uniqueCode,value,oldValue) => {
            changeData(uniqueCode,value,oldValue);
            openState();
    }

    return (
        <React.Fragment >


                    <Confirm2Modal onClose={() => openState()} onConfirm={() => _onRemarkConfirm(textValue)}>
                            <table className="remark-tbl">
                                <colgroup>
                                    <col width="20px"/>
                                    <col/>
                                    <col width="105px"/>
                                    <col width="80px"/>
                                </colgroup>
                                <tbody>
                                {dataList?.map((od, i) => (
                                    <tr
                                        data-num={i}
                                        key={"createinaddmodal" + i}
                                        onClick={(e) => e.target.closest("tr").classList.toggle("active")}>
                                        <td>
                                            <button className="pop2_close" onClick={(e) => {
                                                _changeRemark(od.uniqueCode, {value: ""})
                                            }}><IoCloseSharp/></button>
                                        </td>
                                        <td style={{padding: "3px"}}>
                                            <div
                                                suppressContentEditableWarning={true}
                                                contentEditable={true}
                                            style={{minHeight: "30px", overflow: "auto",textAlign:"left"}}
                                                onBlur={(e) => change(i, e.target.innerText, 'value')}>{od.value}</div>
                                        </td>
                                        <td>
                                            <button className="pop2_modi" onClick={(e) => {
                                                _changeRemark(od.uniqueCode, {value: od.value},od.oldValue)
                                            }}>일괄 수정
                                            </button>
                                        </td>
                                        <td>
                                            <button className="pop2_modi" onClick={(e) => {
                                                _onRemarkConfirm(od.value)
                                                openState(e)
                                            }}>선택
                                            </button>
                                        </td>
                                    </tr>

                                ))}
                                </tbody>
                            </table>
                        <div className="text-area">
                            <textarea
                                style={{resize: "none", border: "1px solid #000"}}
                                value={textValue}
                            onChange={(e) => {
                                setTextValue(e.target.value);
                            }}/>
                        </div>
                    </Confirm2Modal>


        </React.Fragment>
    );
};

export default React.memo(CustomTextAreaList);
